import type { AiExecutionCheckpoint } from '../../types/aiOperational'

const stateLabel = (checkpoint: AiExecutionCheckpoint) =>
  checkpoint.state ? checkpoint.state.toLowerCase() : 'pending'

export const ExecutionCheckpointPanel = ({ checkpoints }: { checkpoints: AiExecutionCheckpoint[] }) => {
  if (!checkpoints.length) return null
  return (
    <section className="aiExecutionCheckpointPanel" aria-label="Execution checkpoints">
      <div className="aiExecutionPanelHeader">
        <strong>Checkpoints</strong>
        <span>{checkpoints.length}</span>
      </div>
      <ul>
        {checkpoints.slice(0, 5).map((checkpoint) => (
          <li key={checkpoint.id}>
            <span>{checkpoint.title}</span>
            <small>{stateLabel(checkpoint)} · {checkpoint.kind?.toLowerCase().replace(/_/g, ' ') ?? checkpoint.satisfiedBy.toLowerCase().replace(/_/g, ' ')}</small>
            {checkpoint.waitingReason ? <p>{checkpoint.waitingReason}</p> : null}
          </li>
        ))}
      </ul>
    </section>
  )
}
